import React from "react";

interface ProfileAvatarProps {
  picture?: string | null;
  name?: string;
  size?: "xs" | "sm" | "md" | "lg";
  className?: string;
  showDefaultBadge?: boolean;
  platformBadge?: React.ReactNode;
}

const ProfileAvatar: React.FC<ProfileAvatarProps> = ({
  picture,
  name,
  size = "lg",
  className = "",
  showDefaultBadge: _showDefaultBadge = false,
  platformBadge,
}) => {
  const sizes = {
    xs: "h-[38px] w-[38px]",
    sm: "h-8 w-8",
    md: "h-10 w-10",
    lg: "h-12 w-12",
  };

  const ringClass = size === "lg" ? "ring-2 ring-gray-200" : "";

  return (
    <div className={`relative ${sizes[size]} flex-shrink-0 overflow-visible ${className}`}>
      <div className={`h-full w-full overflow-hidden rounded-full bg-gray-100 ${ringClass}`}>
        {picture ? (
          <img
            src={picture}
            alt={name || "Profile picture"}
            className="h-full w-full object-cover"
          />
        ) : (
          <div className="h-full w-full flex items-center justify-center bg-gray-100">
            <svg className="h-full w-full text-gray-300" fill="currentColor" viewBox="0 0 24 24">
              <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z"></path>
            </svg>
          </div>
        )}
      </div>
      {platformBadge && (
        <div className="absolute -bottom-1 -right-1 bg-white rounded-full p-0.5 shadow-sm">
          {platformBadge}
        </div>
      )}
    </div>
  );
};

export default ProfileAvatar;
